import React, { useState, useEffect } from "react";
import { Alert } from "@mui/material";
import Select from "../../ui/PortalSelect";
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { baseURL } from '../backend_url';
import Swal from "sweetalert2";
import axios from 'axios';
import ReactPhoneInput from "react-phone-input-2";
import { StatusBadge } from '../../ui';
import { loadAccessibleCompanies, readSessionUser } from '../accountAccess';
import { buildCompanyOptions, findCompanyById } from '../companyLocation/companySelection';
import UserAccountAllocation from './UserAccountAllocation';
import { messageFromError, readJsonResponse } from '../saveResponse';
import { getEntitySelectProps } from '../../ui/selectPresentation';
import {
  customizedOtpForPayload,
  normalizeCustomizedOtpInput,
  roleAllowsCustomizedOtp,
  validateCustomizedOtp,
} from './customizedOtp';
import {
  areAllCurrentLocationsAllocated,
  canonicalizeLocationAllocations,
} from './locationAllocations';
import { canonicalizeAccountAllocations } from './accountAllocations';

export default function UpdateForm({ accessType }) {
  const [companyDetail, setcompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [userDetail, setUserDetail] = useState([]);
  const [userID, setUserID] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [customizedOtp, setCustomizedOtp] = useState("");
  const [checkboxFlag, setCheckboxFlag] = useState(false);
  const [validationMsg, setValidationMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationsLoadedFor, setLocationsLoadedFor] = useState('');
  const [checkedState, setCheckedState] = useState({});
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [maxUser, setMaxUser] = useState(null);
  const [existingUser, setExistingUser] = useState(null);
  const [roleDetail, setRoleDetail] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [accountAllocated, setAccountAllocated] = useState([]);
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [phone2, setPhone2] = useState("");
  const [sq1, setSq1] = useState("");
  const [sq2, setSq2] = useState("");
  const [sq3, setSq3] = useState("");
  const [q1, setq1] = useState("In what city were you born?");
  const [q2, setq2] = useState("What is the name of your favorite pet?");
  const [q3, setq3] = useState("At what age did you start school?");
  const [submitAndSendMail, setSubmitAndSendMail] = useState("No");

  const [selectAllLocation, setSelectAllLocation] = useState(false);

  // form validation rules 
  const validationSchema = Yup.object().shape({

    password: Yup.string()
      .required('Password is required')
      .min(8, 'Must be greater than 8 characters')
      .max(200, 'Must be less than 200 characters')
      .matches(
        // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
        "Must Contain atleast 8 Characters, One Uppercase, One Lowercase and One Number "
      )

  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  // get functions to build form with useForm() hook
  const { register, handleSubmit, setValue, formState: { errors } } = useForm(formOptions);


  //API call
  useEffect(() => {
    let active = true;
    const { user: foundUser, error } = readSessionUser();
    if (error) {
      setcompanyDetail([]);
      setValidationMsg(error);
      return undefined;
    }

    setLoggedInUserDetail(foundUser);
    loadAccessibleCompanies(baseURL, foundUser, 'User_Account Access')
      .then((accounts) => {
        if (active) setcompanyDetail(accounts);
      })
      .catch((loadError) => {
        if (active) {
          setcompanyDetail([]);
          setValidationMsg(loadError.message || 'Accounts could not be loaded.');
        }
      });

    return () => {
      active = false;
    };
  }, []);

  // Load the selected account by its immutable ID. Duplicate company names
  // are valid and must not collapse into the first matching tenant.
  useEffect(() => {
    const company_obj = findCompanyById(companyDetail, company_id);
    if (!company_obj) {
      setLocationDetail([]);
      setCheckedState({});
      setLocationsLoadedFor('');
      setSelectAllLocation(false);
      return undefined;
    }

    let active = true;
    const selectedCompanyId = String(company_obj._id);
    setMaxUser(company_obj.no_of_users);
    setSelectAllLocation(false);
    setLocationDetail([]);
    setCheckedState({});
    setLocationsLoadedFor('');

    //API call for getting data from DB
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(
      baseURL + '/get_user_details/' + selectedCompanyId
      + '?companyNumber=' + encodeURIComponent(selectedCompanyId),
      requestOptions
    )
      .then((res) => readJsonResponse(res, 'Users'))
      .then((data) => {
        if (!active) return;
        if (data === 'New Entry !!') {
          setExistingUser(0);
          setUserDetail([]);
          return;
        }
        if (!data || typeof data !== 'object' || !Array.isArray(data.res)) {
          throw new Error('The server did not return a valid User list.');
        }
        setExistingUser(Number(data.existing_users) || 0);
        setUserDetail(data.res);
      })
      .catch((error) => {
        if (!active) return;
        setExistingUser(null);
        setUserDetail([]);
        setValidationMsg(messageFromError(
          error,
          'Users could not be loaded for this account. Please try again.',
        ));
      });

    //API call for getting data from Location DB
    const requestOptions2 = {
      method: "GET",
      mode: 'cors',
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(
      baseURL + '/get_company_location/' + selectedCompanyId
      + '?companyNumber=' + encodeURIComponent(selectedCompanyId),
      requestOptions2
    )
      .then((res) => readJsonResponse(res, 'Account locations'))
      .then((data) => {
        if (!active) return;
        if (!data || !Array.isArray(data.res)) {
          throw new Error('The server did not return a valid Account location list.');
        }
        const locations = data.res;
        setLocationDetail(locations);
        setLocationsLoadedFor(selectedCompanyId);
      })
      .catch((error) => {
        if (!active) return;
        setValidationMsg(messageFromError(
          error,
          'Account locations could not be loaded. Please try again.',
        ));
      });

    axios.get(
      baseURL + "/user_role_setup/" + selectedCompanyId + "*Corporate"
      + "?companyNumber=" + encodeURIComponent(selectedCompanyId)
    )
      .then((res) => {
        if (!active) return;
        if (!Array.isArray(res.data)) {
          throw new Error('The server did not return a valid Role list.');
        }
        setRoleDetail(res.data)
      })
      .catch((error) => {
        if (!active) return;
        setRoleDetail([]);
        setValidationMsg(messageFromError(
          error,
          'Roles could not be loaded for this account. Please try again.',
        ));
      })

    setUserEmail(null);
    setUserID("");
    setPassword("");
    setShowPassword(false);

    return () => {
      active = false;
    };
  }, [companyDetail, company_id]);



  //Trigger on USER ID dropdown changes
  useEffect(() => {
    if (!userEmail
        || !Array.isArray(userDetail)
        || locationsLoadedFor !== String(company_id)) {
      return;
    }

    const selectedUser = userDetail.find(
      (value) => value?.user_email === userEmail
    );
    if (!selectedUser) return;

    const currentAllocations = canonicalizeLocationAllocations(
      locationDetail,
      selectedUser.location_allocated,
    );

    setUserID(selectedUser._id);
    setUserName(selectedUser.user_name || '');
    setCheckboxFlag(Boolean(selectedUser.is_active));
    setPassword(selectedUser.password || '')
    setCheckedState(currentAllocations);
    setSelectAllLocation(
      areAllCurrentLocationsAllocated(locationDetail, currentAllocations)
    );
    setCustomizedOtp(selectedUser.customized_otp || "");
    setSelectedRole(selectedUser.selected_role || '');
    setAccountAllocated(canonicalizeAccountAllocations(
      companyDetail,
      company_id,
      selectedUser.account_allocated,
    ));
    setPhone2(selectedUser.contact_no || '');
    setSq1(selectedUser.s_a1 || '');
    setSq2(selectedUser.s_a2 || '');
    setSq3(selectedUser.s_a3 || '');
  }, [companyDetail, company_id, locationDetail, locationsLoadedFor, userDetail, userEmail]);



  //OnSubmit code
  const submitHandler = () => {
    // e.preventDefault();
    setSuccessMsg("");
    setLoading(true);
    setValidationMsg("");

    if (companyName === '' || userEmail === '') {
      const message = companyName === ''
        ? 'Please select an account name to proceed'
        : 'Please select a User to proceed';
      setValidationMsg(message)
      Swal.fire({ icon: 'error', title: 'User was not updated', text: message });


      setLoading(false)
    }
    else {

      if (locationsLoadedFor !== String(company_id)) {
        const message = 'Account locations are still loading. Please wait and try again.';
        setValidationMsg(message)
        Swal.fire({ icon: 'info', title: 'Locations are loading', text: message });
        setLoading(false)
        return;
      }

      if (sq1.toString().trim() === '') {
        Swal.fire("Please fill answer for security question 1")
        setLoading(false)
        return;
      }
      if (sq2.toString().trim() === '') {
        Swal.fire("Please fill answer for security question 2")
        setLoading(false)
        return;
      }
      if (sq3.toString().trim() === '') {
        Swal.fire("Please fill answer for security question 3")
        setLoading(false)
        return;
      }
      
      const customizedOtpError = validateCustomizedOtp(selectedRoleRecord, customizedOtp);
      if (customizedOtpError) {
        Swal.fire({ icon: 'error', title: 'Invalid Customized OTP', text: customizedOtpError })
        setLoading(false)
        return;
      }

      const locationAllocatedPayload = canonicalizeLocationAllocations(
        locationDetail,
        checkedState,
      );
      const accountAllocatedPayload = canonicalizeAccountAllocations(
        companyDetail,
        company_id,
        accountAllocated,
      );

      //API call for updating DB data
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_id: company_id.toString(),
          companyNumber: company_id.toString(),
          is_active: checkboxFlag,
          password: password,
          location_allocated: locationAllocatedPayload,
          selected_role: selectedRole,
          account_allocated: accountAllocatedPayload,
          user_name: userName,
          customized_otp: customizedOtpForPayload(selectedRoleRecord, customizedOtp),
          updated_by: loggedInUserDetail.userEmail,
          contact_no: phone2,
          s_q1: q1,
          s_q2: q2,
          s_q3: q3,
          s_a1: sq1.toString().trim(),
          s_a2: sq2.toString().trim(),
          s_a3: sq3.toString().trim(),
          userEmail: userEmail,
          send_mail: submitAndSendMail

        }),
      };

      const submittedUserId = String(userID);
      const submittedUserEmail = userEmail;

      const resetForm = () => {
        setUserID("")
        setUserName("")
        setCustomizedOtp("")
        setCheckboxFlag(false)
        setUserEmail('')
        setCompanyName('')
        setcompany_id('')
        setShowPassword(false)
        setMaxUser(null)
        setExistingUser(null)
        setPhone2("")
        setSq1("")
        setSq2("")
        setSq3("")
        setSubmitAndSendMail("No")
        setAccountAllocated([])
      }

      fetch(baseURL + "/update_user/" + submittedUserId, requestOptions)
        .then((res) => readJsonResponse(res, 'User update'))
        .then((data) => {
          if (String(data) !== submittedUserId) {
            throw new Error('The server did not confirm the updated User ID. Your form has been kept.');
          }

          const message = "Edits successfully completed for the User Email - " + submittedUserEmail;
          setSuccessMsg(message);
          resetForm()
          Swal.fire({ icon: 'success', title: 'User updated', text: message });
        })
        .catch(error => {
          console.error('Unable to update user:', error)
          const message = messageFromError(error, 'Unable to update User. Please try again.');
          setValidationMsg(message)
          Swal.fire({ icon: 'error', title: 'User was not updated', text: message });
        })
        .finally(() => setLoading(false));
    }
  }; //submitHandler func ends here


  const handleChecked = () => {

    if (checkboxFlag === true) {

      Swal.fire({
        title: 'Do you really want to deactivate this user ?',

        showCancelButton: true,
        confirmButtonText: 'Yes',


      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          setCheckboxFlag(!checkboxFlag);
        }
      })
    }

    if (checkboxFlag === false) {

      Swal.fire({
        title: 'Do you really want to activate this user ?',

        showCancelButton: true,
        confirmButtonText: 'Yes',


      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          axios.get(
            baseURL + "/check_max_user_limit/" + company_id
            + "?companyNumber=" + encodeURIComponent(company_id.toString())
          )
            .then((res) => {

              if (res.data === 'failed') {
                const message = "You have already touched the limit of maximum number of users. Please contact support@caledontechnologies.com to increase the limit";
                setValidationMsg(message)
                Swal.fire({ icon: 'error', title: 'User cannot be activated', text: message });
              }
              else if (res.data === 'success') {
                setCheckboxFlag(!checkboxFlag);
              }
              else {
                throw new Error('The server did not confirm whether another active User is allowed.');
              }
            })
            .catch((error) => {
              console.error('Unable to verify the User limit:', error);
              const message = messageFromError(error, 'Unable to verify the User limit. Please try again.');
              setValidationMsg(message);
              Swal.fire({ icon: 'error', title: 'User status was not changed', text: message });
            })
        }
      })
    }


  };

  //Option for company name
  const RoleNameOptions = roleDetail.map((value) => (

    { value: value.role_name, label: value.role_name }
  ));

  const selectedRoleRecord = roleDetail.find((value) => value.role_name === selectedRole) || null;
  const canUseCustomizedOtp = roleAllowsCustomizedOtp(selectedRoleRecord);

  useEffect(() => {
    if (selectedRoleRecord && !roleAllowsCustomizedOtp(selectedRoleRecord)) {
      setCustomizedOtp('');
    }
  }, [selectedRoleRecord]);

  const handleInputChangeRoleName = characterEntered => {
    const nextRoleName = characterEntered?.value || '';
    const nextRole = roleDetail.find((value) => value.role_name === nextRoleName) || null;
    setSelectedRole(nextRoleName);
    if (!roleAllowsCustomizedOtp(nextRole)) setCustomizedOtp('');
    setAccountAllocated((current) => (
      current.includes(String(company_id)) ? current : [String(company_id), ...current]
    ));
  };

  //Option for company name
  const companyNameOptions = buildCompanyOptions(companyDetail);
  const selectedCompanyOption = companyNameOptions.find(
    (option) => option.value === String(company_id),
  ) || null;

  const handleInputChangeCompanyName = characterEntered => {
    const company = findCompanyById(companyDetail, characterEntered?.value);
    setcompany_id(characterEntered?.value || '');
    setCompanyName(company?.company_name || '');
    setUserDetail([]);
    setUserEmail('');
    setUserID('');
    setSelectedRole('');
    setCustomizedOtp('');
    setRoleDetail([]);
    setAccountAllocated(characterEntered?.value ? [String(characterEntered.value)] : []);
    setLocationDetail([]);
    setCheckedState({});
    setLocationsLoadedFor('');
    setSelectAllLocation(false);
  };


  //Option for user Email
  const userEmailOptions = userDetail.map((value) => (

      { value: value.user_email, label: value.user_email }
    ));

  const handleInputChangeUserEmail = characterEntered => {
    setUserEmail(characterEntered.value);
  }

  const handleGeneratePassword = () => {
    setPassword(generatePassword())
  }
  const generatePassword = () => {
    var length = 8,
      charset2 = "abcdefghijklmnopqrstuvwxyz",
      charset1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      charset3 = "0123456789",
      retVal = "";
    for (var i = 0, n = charset1.length; i < 3; ++i) {
      retVal += charset1.charAt(Math.floor(Math.random() * n));
    }

    for (var i = 0, n = charset2.length; i < 2; ++i) {
      retVal += charset2.charAt(Math.floor(Math.random() * n));
    }

    for (var i = 0, n = charset3.length; i < 3; ++i) {
      retVal += charset3.charAt(Math.floor(Math.random() * n));
    }
    return shuffle_pass(retVal);
  }


  const shuffle_pass = (pass_str) => {
    var a = pass_str.split(""),
      n = a.length;

    for (var i = n - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i];
      a[i] = a[j];
      a[j] = tmp;
    }
    return a.join("");
  }


  //Location Tick Check 
  const handleLocationCheck = (location_name) => {

    const location_hash_temp = { ...checkedState };
    location_hash_temp[location_name] = !location_hash_temp[location_name];
    setCheckedState(location_hash_temp);

    let arr = Object.keys(location_hash_temp);
    let flag = true;
    for (let i = 0; i < arr.length; i++) {

      if (location_hash_temp[arr[i]] === false) {
        flag = false;
        break;
      }
    }
    if (flag) {
      setSelectAllLocation(true);
    }
    else {
      setSelectAllLocation(false);
    }

  }


  //Location Tick Check 
  const handleAllLocationCheck = () => {

    const location_hash_temp = { ...checkedState };
    setSelectAllLocation(!selectAllLocation);

    let arr = Object.keys(location_hash_temp);
    for (let i = 0; i < arr.length; i++) {

      if (!selectAllLocation) {
        location_hash_temp[arr[i]] = true
      }
      else {
        location_hash_temp[arr[i]] = false
      }
    }

    setCheckedState(location_hash_temp);

  }


  return (
    <>
      <div className="row pt-4">
        <div className="col-8 mx-3">
          <span style={{ color: '#1E1E1E', fontSize: '21px' }}>{accessType === 'View' ? "Select User to view details:" : "Select User to edit details:"} </span>
        </div>
      </div>

      <div className="row pt-5">
        {/* <div className="col-1"></div> */}
        <div className="col-8 mx-3">
          <form className="row g-3" onSubmit={handleSubmit(submitHandler)}>
            {validationMsg ? (
              <Alert severity="error">{validationMsg}!</Alert>
            ) : (
              ""
            )}

            {successMsg ?

              (

                <div className="alert alert-success alert-dismissible fade show" role="alert">
                  {successMsg}
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setSuccessMsg('')}></button>
                </div>
              )
              : ""}



            <div className="col-md-2 mb-3">
              <label htmlFor="company_name" className="form-label">
                Account Name
              </label>
            </div>

            <div className="col-md-5 mb-3">

              <Select
                {...getEntitySelectProps()}
                value={selectedCompanyOption}
                inputId="company_name"
                name="company_name"
                options={companyNameOptions}
                onChange={handleInputChangeCompanyName}
                placeholder="Select Account name"
                isClearable

              />

            </div>


            <div className="col-md-1 mb-3"></div>

            <div className="col-md-2 mb-3">
              {/* <label htmlFor="company_id" className="form-label">
                Account ID
              </label> */}
            </div>
            <div className="col-md-2 mb-3">
              {/* <input
                type="text"
                className="form-control"
                value={company_id}
                id="company_id"
                disabled
              /> */}
            </div>

            {userDetail === "New Entry !!" ? (
              ""
            ) : (
              <>
                <div className="col-md-2 mb-3">
                  <label htmlFor="user_email" className="form-label">
                    User Email
                  </label>
                </div>
                <div className="col-md-5 mb-3">

                  <Select
                    value={{ value: userEmail, label: userEmail ? userEmail : "Select User Email" }}
                    inputId="user_email"
                    name="user_email"
                    options={userEmailOptions}
                    onChange={handleInputChangeUserEmail}
                  />
                </div>
                <div className="col-md-1 mb-3"></div>
              </>
            )}

            {userDetail === "New Entry !!" ? (
              <Alert severity="error">
                No existing user for selected Account
              </Alert>
            ) : (
              <>
                <div className="w-100" aria-hidden="true"></div>
                <div className="col-md-2 mb-3">
                  <label htmlFor="contact_no" className="form-label">
                    Contact No.
                  </label>
                </div>
                <div className="col-md-5 mb-3 user-phone-field">
                  <ReactPhoneInput
                    enableSearch
                    searchPlaceholder="Search country"
                    value={phone2}
                    placeholder="Enter contact number"
                    onChange={(value) => setPhone2(value)}
                    disabled={accessType === 'View'}
                    inputProps={{
                      id: 'contact_no',
                      name: 'contact_no',
                      'aria-label': 'Contact number',
                    }}
                  />

                </div>
                <div className="col-md-5 mb-3"></div>


                <div className="col-md-2 mb-3">
                  <label htmlFor="existing_user" className="form-label">
                    Role Name
                  </label>
                </div>
                <div className="col-md-5 mb-3">
                  <Select
                    value={{ value: selectedRole, label: (selectedRole ? selectedRole : "Select Role Name") }}
                    inputId="role_name"
                    name="role_name"
                    options={RoleNameOptions}
                    onChange={handleInputChangeRoleName}
                    isDisabled={accessType === 'View'}
                  />

                </div>


                <div className="col-md-1 mb-3"></div>
                <div className="col-12">
                  <UserAccountAllocation
                    accounts={companyDetail}
                    homeAccountId={company_id}
                    role={selectedRoleRecord}
                    allocatedAccountIds={accountAllocated}
                    onChange={setAccountAllocated}
                    disabled={accessType === 'View'}
                  />
                </div>


                <div className="col-md-2 mb-3">
                  <label htmlFor="max_user" className="form-label">
                    Max Allowed Users
                  </label>
                </div>
                <div className="col-md-2 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    value={maxUser}
                    id="max_user"
                    disabled
                  />
                </div>

                {userID ? (
                  <>


                    <div className="col-md-2 mb-3">
                      <label htmlFor="user_id" className="form-label">
                        User Name
                      </label>
                    </div>
                    <div className="col-md-5 mb-3">
                      <input
                        type="text"
                        className="form-control"
                        value={userName ?? ""}
                        id="user_name"
                        onChange={(e) => setUserName(e.target.value)}
                      />

                    </div>



                    <div className="col-md-1 mb-3"></div>
                    <div className="col-md-2 mb-3">
                      <label htmlFor="existing_user" className="form-label">
                        Existing Active Users
                      </label>
                    </div>
                    <div className="col-md-2 mb-3">
                      <input
                        type="text"
                        className="form-control"
                        value={existingUser}
                        id="existing_user"
                        disabled
                      />
                    </div>

                    {!(accessType === 'View') && (<>
                      <div className="col-md-2 mb-3">

                        <label htmlFor="password" className="form-label">
                          Password
                        </label>

                      </div>
                      <div className="col-md-5 mb-3">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={`form-control ${errors.password ? 'is-invalid' : ''}`} {...register('password')}
                          value={password}
                          id="password"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <div className='row mx-1'>
                          <div className="col-md-3 form-check mt-3">

                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                              checked={showPassword} onChange={() => setShowPassword(!showPassword)} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                              Show Password
                            </label>

                          </div>
                          <div className="col-md-2 mt-3"></div>
                          <div className="col-md-1 mt-3">
                            <span title='Click to auto generate password' onClick={handleGeneratePassword} style={{ cursor: 'pointer' }}><AutorenewIcon /> </span>
                          </div>

                          <div className="col-md-6 mt-3">
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                              Generate Password
                            </label>
                          </div>

                        </div>
                        <div className="invalid-feedback">{errors.password?.message}</div>
                      </div>
                      {canUseCustomizedOtp && (
                        <>
                          <div className="w-100" aria-hidden="true"></div>
                          <div className="col-md-2 mb-3">
                            <label htmlFor="customized_otp" className="form-label">
                              Customized OTP
                            </label>
                          </div>
                          <div className="col-md-5 mb-3">
                            <input
                              type="text"
                              className="form-control"
                              value={customizedOtp || ""}
                              id="customized_otp"
                              name="customized_otp"
                              maxLength={6}
                              inputMode="numeric"
                              autoComplete="one-time-code"
                              pattern="[0-9]{6}"
                              disabled={accessType === 'View'}
                              aria-describedby="customized_otp_help"
                              onChange={(event) => setCustomizedOtp(normalizeCustomizedOtpInput(event.target.value))}
                            />
                            <div id="customized_otp_help" className="form-text">
                              Optional. Enter exactly 6 digits to use this fixed login OTP instead of an emailed OTP.
                            </div>
                          </div>
                          <div className="col-md-5 mb-1"></div>
                        </>
                      )}

                      {/* Security Question Start */}
                      <div className='row'>
                        <div className="col-md-2 mb-3">
                          <label htmlFor="company_name" className="form-label">
                            Security Question 1
                          </label>
                        </div>
                        <div className="col-md-3  mb-3">


                          <label htmlFor="q1" className="form-label">
                            {q1}
                          </label>

                        </div>
                        <div className="col-md-3  mb-3">

                          <input
                            type="text"
                            className="form-control"
                            value={sq1}
                            id="q1"
                            onChange={(e) => setSq1(e.target.value)}
                          />
                        </div>
                        {/* <div className="col-md-1 mb-3"></div> */}
                        <div className="col-md-2 mb-3">

                        </div>
                        <div className="col-md-2 mb-3">
                          {/* <input
                  type="text"
                  className="form-control"
                  value={company_id}
                  id="company_id"
                  disabled
                /> */}
                        </div>
                      </div>

                      <div className='row'>
                        <div className="col-md-2 mb-3">
                          <label htmlFor="company_name" className="form-label">
                            Security Question 2
                          </label>
                        </div>
                        <div className="col-md-3  mb-3">


                          <label htmlFor="q2" className="form-label">
                            {q2}
                          </label>

                        </div>
                        <div className="col-md-3  mb-3">
                          <input
                            type="text"
                            className="form-control"
                            value={sq2}
                            id="q2"
                            onChange={(e) => setSq2(e.target.value)}
                          />
                        </div>
                        {/* <div className="col-md-1 mb-3"></div> */}
                        <div className="col-md-2 mb-3">

                        </div>
                        <div className="col-md-2 mb-3">
                          {/* <input
                  type="text"
                  className="form-control"
                  value={company_id}
                  id="company_id"
                  disabled
                /> */}
                        </div>

                      </div>

                      <div className='row'>
                        <div className="col-md-2 mb-3">
                          <label htmlFor="company_name" className="form-label">
                            Security Question 3
                          </label>
                        </div>
                        <div className="col-md-3  mb-3">


                          <label htmlFor="q3" className="form-label">
                            {q3}
                          </label>

                        </div>
                        <div className="col-md-3  mb-3">

                          <input
                            type="text"
                            className="form-control"
                            value={sq3}
                            id="q3"
                            onChange={(e) => setSq3(e.target.value)}
                          />
                        </div>
                        {/* <div className="col-md-1 mb-3"></div> */}
                        <div className="col-md-2 mb-3">

                        </div>
                        <div className="col-md-2 mb-3">
                          {/* <input
                  type="text"
                  className="form-control"
                  value={company_id}
                  id="company_id"
                  disabled
                /> */}
                        </div>

                      </div>
                      {/* Security Question End */}

                    </>)
                    }
                    <div className="col-md-2 mb-1">User Status</div>


                    <div className="col-md-10 mb-4">

                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="gridCheck"
                          checked={checkboxFlag ?? ""}
                          onChange={handleChecked}
                          style={{ width: "50px", height: "25px", marginRight: "8px" }}
                          disabled={accessType === 'View'}
                        />
                        <label className="form-check-label" htmlFor="gridCheck" style={{ margin: 4 }}>
                          <StatusBadge
                            status={checkboxFlag ? "active" : "disabled"}
                            label={checkboxFlag ? "Active" : "Deactivated"}
                            size="small"
                          />
                        </label>
                      </div>


                    </div>
                    <div className="col-md-5 mb-3" >
                      <span style={{ color: '#1E1E1E', fontSize: '21px' }}>Location Access:</span>
                      <div className="mvp-data-region mt-2" role="region" aria-label="Location access">
                        <table className="table text-center" >
                          <thead>
                            <tr >
                              <th scope="col" style={{ width: '150px' }} >Location Name</th>
                              <th scope="col" style={{ width: '70px' }}>Allocated</th>
                            </tr>
                          </thead>
                          <tbody >
                            {locationDetail.length > 0 &&
                              <tr>
                                <td>{"Select All"}</td>
                                <td style={{ width: '70px' }}>
                                  <input type="checkbox" className='form-check-input' checked={selectAllLocation} onChange={() => { handleAllLocationCheck() }} disabled={accessType === 'View'} aria-label="Allocate all locations" />
                                </td>
                              </tr>
                            }
                            {
                              locationDetail.length > 0 ? (
                                locationDetail.map((val) => (
                                  <tr key={val._id}>
                                    <td>{val.location_name}</td>
                                    <td style={{ width: '70px' }}>
                                      <input type="checkbox" className='form-check-input' checked={checkedState[val.location_id]} onChange={() => handleLocationCheck(val.location_id)} disabled={accessType === 'View'} aria-label={`Allocate ${val.location_name}`} />
                                    </td>
                                  </tr>
                                ))

                              ) : ""
                            }

                          </tbody>
                        </table>
                      </div>


                    </div>

                  </>
                ) : (
                  "")}
                <div className="col-md-2"></div>
                <div className="row">
                  <div className="col-md-5 mb-4 ">
                    {!(accessType === 'View') && (loading ? (

                      <button className="btn btn-success" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 5 }}></span>
                        Update
                      </button>

                    ) : (
                      <button type="submit" className="btn btn-success" >
                        Update
                      </button>

                    ))}
                  </div>
                  <div className="col-md-5 mb-4 ">
                    {!(accessType === 'View') && (loading ? (

                      <button className="btn btn-info" type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 5 }}></span>
                        Update & Send Mail
                      </button>

                    ) : (
                      <button type="submit" className="btn btn-info" onClick={() => setSubmitAndSendMail("Yes")}>
                        Update & send Mail
                      </button>

                    ))}
                  </div>
                </div>

              </>
            )}
          </form>

        </div>

      </div>
    </>
  );
}
